"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricDataStatsSourceEnum = void 0;
var MetricDataStatsSourceEnum;
(function (MetricDataStatsSourceEnum) {
    MetricDataStatsSourceEnum["StatsChannelLive"] = "stats_channel_live";
    MetricDataStatsSourceEnum["StatsChannel"] = "stats_channel";
    MetricDataStatsSourceEnum["StatsUser"] = "stats_user";
    MetricDataStatsSourceEnum["UserActivityTimeline"] = "user_activity_timeline";
})(MetricDataStatsSourceEnum = exports.MetricDataStatsSourceEnum || (exports.MetricDataStatsSourceEnum = {}));
